import React from 'react'

interface Props {
  className?: string;
  style?: React.CSSProperties;
}

export const FailureX = (props: Props) => {
  return (
    <svg className={props.className} style={props.style} width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="64" height="64" rx="32" fill="#FED19A"/>
      <path d="M44 20L20 44" stroke="#1E1E28" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M20 20L44 44" stroke="#1E1E28" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
